module.exports = __webpack_public_path__ + "static/undraw_update_uxn2-13469cb58329704a5d8655aea2602884.svg";